import { Component, OnInit, OnDestroy, ViewEncapsulation, AfterViewInit, Input } from '@angular/core';
import { StackedBarWidgetsService } from './stacked-bar-widget.service';
declare var pg: any;

@Component({
  selector: 'stacked-bar-widget',
  templateUrl: './stacked-bar-widget.component.html',
  styleUrls: ['./stacked-bar-widget.component.scss'],
  encapsulation:ViewEncapsulation.None
})

export class StackedBarWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
   /* // si agrego 3 elementos al arreglo salen 3 columnas
   ejemplo chartData: any[] = [{
      category : "Por Estado",
      detail: "Contratos Vigentes por Estado",
      data: [
        {
        "key": "Por Liquidar",
        "values": [[0, 10],[1, 3],[2, 6]],
        },
        {
          "key": "Por Vacaciones",
          "values": [[0, 6],[1, 18],[2, 10]],
        },
        {
          "key": "Activos",
          "values": [[0, 83],[1, 78],[2, 75]],
        }
      ]
    }]
   */
  chartOptions: any[] = [];
  timeout;

  @Input() title = "Unknow" ;
  @Input() functionArrData = [
    // {
    //   category : "Activos,No Liq.",
    //   detail: "Contratos Activos (No Liq.)",
    //   function:"getContratoPorTipo"
    // },
    // {
    //   category : "Por Estado",
    //   detail: "Contratos Vigentes por Estado",
    //   function:"getContratoPorEstado"
    // },
    // {
    //   category : "Liquidación",
    //   detail: "En Proceso de Liquidacion",
    //   function:"getContratoPorTipo"
    // },
  ] ;

  query: string[] =[]; // sentencia query para obtener datos
  loading = false;
  currentTab = 0;

  gralTitle = "" ;
  resumenTitle = "" ;
   chartData: any[] = [
  //   {
  //     category : "Activos,No Liq.",
  //     detail: "Contratos Activos (No Liq.)",
  //     data: [
  //       {
  //       "key": "Fijos",
  //       "values": [],
  //       },
  //       {
  //         "key": "Indefinidos",
  //         "values": [],
  //       }
  //     ]
  //   },
  //   {
  //     category : "Liquidación",
  //     detail: "En Proceso de Liquidacion",
  //     data: [
  //       {
  //       "key": "Sin Liquidación",
  //       "values": [],
  //       },
  //       {
  //         "key": "Con Liquidación",
  //         "values": [],
  //       }
  //     ]
  //   },
  //   {
  //     category : "Por Estado",
  //     detail: "Contratos Vigentes por Estado",
  //     data: [
  //       {
  //       "key": "Por Liquidar",
  //       "values": [[0, 10]],
  //       },
  //       {
  //         "key": "Por Vacaciones",
  //         "values": [[0, 6]],
  //       },
  //       {
  //         "key": "Activos",
  //         "values": [[0, 83]],
  //       }
  //     ]
  //   }
  ]


  constructor(private stackedBarWidgetsService: StackedBarWidgetsService) {
  }

  ngOnInit() {
    this.loading = true;
    this.functionArrData.forEach((element,i) => {
      //  console.log(element.category)
      this.stackedBarWidgetsService.getFunctionByName(element.function)
      .toPromise().then( (res: any ) => { this.query[i] = res.query; } )
      .then( () => {this.getData(i); })
      .catch ( err => {
        console.log(err);
        this.loading = false;
      } );
    });
  }

  getData(iQuery) {
    this.loading = true;
    const args = { param: {}, query: this.query[iQuery] };
    this.stackedBarWidgetsService.getData(args).toPromise()
    .then (async (res: any) => {
       // console.log(iQuery , res);
        await this.buildArrData(iQuery, res);
        if ((this.functionArrData.length - 1) === iQuery) {
            console.log('Fin de carga de datos en array')
             this.chartData = this.functionArrData;
            //this.loadWidgets();

           //  console.log('chartData', this.chartData)

           //  console.log('functionArrData' , this.functionArrData)

            // this.gralTitle = this.functionArrData[0].detail;
        }
        this.loading = false;
    })
    .catch ( err => {console.log(err); } );
  }

  buildArrData( i, arrOriginal: any[]) {
    return new Promise (resolve => {
      let total = 0;
      let mayorValue = 0 ;
      let mayorKey = '' ;
      this.functionArrData[i]['data'] = arrOriginal.map (item => {
        // acumular valores e identificar mayor key y valor
        total += item[1] ; // si hay varias filas en el registro, se acumulan los valore
        if (item[1] > mayorValue) {
          mayorKey = item[0] ;
          mayorValue = item[1];
        }
        return  {key : item[0] , values : [[0, item[1]]] };
      } );
      this.functionArrData[i]['mayor'] = mayorValue;
      this.functionArrData[i]['mayorKey'] = mayorKey;
      this.functionArrData[i]['total'] = total; //
      // this._detail = `${mayorValue} de ${total.toString()}${this.detail}`;
      // this._value = ((mayorValue  / total ) * 100).toFixed(2).toString() +  this.value ;
      // this._title = `${this.title}${mayorKey}`;
      // console.log('fin carga de datos' + i, this.functionArrData[i]);
      resolve(0); // condicion para indicar que la promesa termino, sino se envia queda en espera
    });
  }


  ngOnInitx() {
    //Generate Random Data
    
    var max = 90;
    var min = 10;
    
    for(var j=0; j < 2; j++) {      
      let data = [[],[]];
      for(var i=0; i < 3; i++) {
        let x = [i,Math.round(Math.random() * (max - min) + min)]
        data[0].push(x);
        x = [i,Math.round(Math.random() * (max - min) + min)]
        data[1].push(x)
      }

      this.chartData[j].data[0].values = data[0];
      this.chartData[j].data[1].values = data[1];
    }

    //this.chartData[1]["values"] = data[1]

   // console.log(this.chartData)

    this.gralTitle = this.chartData[0].detail;

  }

  ngAfterViewInit() {
    this.timeout = setTimeout(() => {
      this.functionArrData.forEach((element,i) => {        
        this.chartOptions[i] = {
          chart: {
            type: 'multiBarChart',   // multiBarHorizontalChart  // multiBarChart
            // color: [
            //   pg.getColor('complete'),
            //   pg.getColor('master-light')
            // ],
            x: function (d) { return d[0]; },
            y: function (d) { return d[1]; },
            multibar:{
              stacked:true
            },
            showControls:false,
            useInteractiveGuideline: false,
            margin: {
              top: 0,
              right:0,
              bottom:0,
              left:0
            },
            yDomain: [0, element['total']],
            showLegend: false,
            showXAxis:false,
            showYAxis:false,
            interactive:false
          }
        }
      });
      // console.log('Info Options' , this.chartOptions)
    }, 2000 );
  }
  ngOnDestroy() {
    clearTimeout(this.timeout)
  }
  showData(e) {
    this.currentTab = e ;
    this.gralTitle = this.chartData[e].detail;
    this.resumenTitle = ((this.functionArrData[e]['mayor'] / this.functionArrData[e]['total']) * 100).toFixed(2).toString() +
    `%, ${this.functionArrData[e]['mayorKey']} : ${this.functionArrData[e]['mayor']} de ${this.functionArrData[e]['total']}`;
  }
  onRefresh() {
    //  this.loadWidgets();
  }
}
